export const checkAuth = (token) => {
  if (token) {
    return true;
  } else {
    return false;
  }
};
